"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Field } from "@base-ui/react/field";
import { forwardRef, useState } from "react";
import { cn } from "../../utils/cn.js";
import { getTooltipSideOffset } from "../Tooltip/utils.js";
import { inputButtonVariants } from "./InputButton.variants.js";
import { InputButtonWrapper } from "./InputButtonWrapper.js";
const InputButton_InputButton = /*#__PURE__*/ forwardRef(function({ label, placeholder, value, isLabelHidden, helperText, errorText, iconLeft, iconRight, emphasis, size, className, isDisabled, errorMessage, onClick, toggleEvent, ...props }, ref) {
    const [internalToggleState, setInternalToggleState] = useState(false);
    const tooltipSideOffset = getTooltipSideOffset(size, true);
    const hasPlaceholder = Boolean(placeholder);
    const hasValue = Boolean(value);
    const isToggled = toggleEvent ?? internalToggleState;
    const styles = inputButtonVariants({
        emphasis,
        size,
        hasPlaceholder,
        hasValue,
        isDisabled,
        error: Boolean(errorMessage)
    });
    const buttonText = value ?? placeholder ?? '';
    const handleButtonClick = (e)=>{
        if (isDisabled) return;
        if (void 0 === toggleEvent) setInternalToggleState((prev)=>!prev);
        if (onClick) {
            e.stopPropagation();
            onClick(e);
        }
    };
    return /*#__PURE__*/ jsxs(Field.Root, {
        className: cn(styles.root(), className),
        disabled: isDisabled,
        children: [
            /*#__PURE__*/ jsx(Field.Control, {
                render: (controlProps)=>/*#__PURE__*/ jsx(InputButtonWrapper, {
                        ...controlProps,
                        ...props,
                        styles: styles,
                        iconLeft: iconLeft,
                        iconRight: iconRight,
                        handleButtonClick: handleButtonClick,
                        isDisabled: isDisabled,
                        buttonText: buttonText,
                        errorMessage: errorMessage,
                        tooltipSideOffset: tooltipSideOffset,
                        label: label,
                        isLabelHidden: isLabelHidden,
                        isToggled: isToggled,
                        ref: ref
                    })
            }),
            helperText || errorText ? /*#__PURE__*/ jsxs("div", {
                className: styles.textSlot(),
                children: [
                    /*#__PURE__*/ jsx(Field.Error, {
                        match: Boolean(errorText),
                        className: styles.errorTextSlot(),
                        "aria-live": "assertive",
                        children: errorText
                    }),
                    !errorText && helperText ? /*#__PURE__*/ jsx(Field.Description, {
                        className: styles.helperTextSlot(),
                        "aria-live": "polite",
                        children: helperText
                    }) : null
                ]
            }) : null
        ]
    });
});
export { InputButton_InputButton as InputButton };
